import React from 'react';
import pt from 'prop-types';
import { MrInputText } from '@ion/components';
import {
  CONSENT_JS_API_GLOBAL_OBJECT,
  CONSENT_JS_API_METHOD,
  CONSENT_JS_API_PROPERTY_PATH,
} from 'app/components/analytics-builder/form-keys';

export default function ConsentSourceJsApiFields({ formState, setField, validateField, validateRequired, resetError }) {
  return (
    <>
      <MrInputText
        label="Global Object"
        onChange={setField}
        value={formState[CONSENT_JS_API_GLOBAL_OBJECT]?.value ?? ''}
        onBlur={validateField}
        onInput={resetError}
        name={CONSENT_JS_API_GLOBAL_OBJECT}
        errorMsg={formState[CONSENT_JS_API_GLOBAL_OBJECT]?.errorMsg}
        validators={[validateRequired()]}
        helperText="A top-level window object exposing your consent reader (e.g. customerConsent)."
        placeholder="customerConsent"
        fullWidth
        required
      />
      <MrInputText
        label="Method"
        onChange={setField}
        value={formState[CONSENT_JS_API_METHOD]?.value ?? ''}
        onBlur={validateField}
        onInput={resetError}
        name={CONSENT_JS_API_METHOD}
        errorMsg={formState[CONSENT_JS_API_METHOD]?.errorMsg}
        validators={[validateRequired()]}
        helperText="A zero-argument method returning a flat code-to-boolean, string, or number map, or a Promise resolving to that map. Callback APIs require a wrapper that handles readiness and returns this shape."
        placeholder="getConsent"
        fullWidth
        required
      />
      <MrInputText
        label="Property Path"
        onChange={setField}
        value={formState[CONSENT_JS_API_PROPERTY_PATH]?.value ?? ''}
        onBlur={validateField}
        onInput={resetError}
        name={CONSENT_JS_API_PROPERTY_PATH}
        errorMsg={formState[CONSENT_JS_API_PROPERTY_PATH]?.errorMsg}
        helperText="Optional dot-path into the returned object (e.g. purposes). Leave blank if the method returns the consent object directly."
        placeholder="purposes"
        fullWidth
      />
    </>
  );
}

ConsentSourceJsApiFields.propTypes = {
  formState: pt.object.isRequired,
  setField: pt.func.isRequired,
  validateField: pt.func.isRequired,
  validateRequired: pt.func.isRequired,
  resetError: pt.func.isRequired,
};
